import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login', name: 'Login',
    component: () => import('../views/Login'),
    meta: { requiresAuth: false },
  },
  { path: '/', redirect: { name: 'Masters' } },
  {
    path: '/masters', name: 'Masters',
    component: () => import('../views/Masters/Masters'),
    meta: { requiresAuth: true },
  },
  {
    path: '/trips', name: 'Trips',
    component: () => import('../views/Trips/Trips'),
    meta: { requiresAuth: true },
  },
 /* {
    path: '/trips-dashboard', name: 'Trips Dashboard',
    component: () => import('../views/Trips/TripsDashboard'),
    meta: { requiresAuth: true },
  }, */
  {
    path: '/customers', name: 'Customers',
    component: () => import('../views/Customers/Customers'),
    meta: { requiresAuth: true },
  },
  {
    path: '/products', name: 'Products',
    component: () => import('../views/Products/Products'),
    meta: { requiresAuth: true },
  }, {
    path: '/purchaseOrder', name: 'Purchase',
    component: () => import('../views/Purchase/Purchase'),
    meta: { requiresAuth: true },
  },{
    path: '/salesOrder', name: 'Sales Orders',
    component: () => import('../views/SalesOrders/SalesOrders'),
    meta: { requiresAuth: true },
  }
]

const router = new VueRouter({ routes })

export default router

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!localStorage.getItem('token')) {
      router.replace({ path: '/login' })
    } else { next() }
  } else {
    if (localStorage.getItem('token')) {
      router.replace({ path: '/masters' })
    } else { next() }
  }
})
